export enum PrescriptionCertificateEnum {
  'VALID' = 'S',
  'INVALID' = 'N'
}